import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: props => {
    const { color, isActive } = props;
    const currentColor = color || COLORS.BLUE;
    return {
      thRoot: `bg-current ${
        isActive
          ? `text-${currentColor}-active arrow-down arrow-${currentColor}-active`
          : `text-${currentColor} focus:text-${currentColor}-active hover:text-${currentColor}-active`
      } text-base text-center transition-color w-full`,
      thBody: 'flex h-full items-center py-4 px-2',
      thChildren: 'flex-grow flex items-center justify-center leading-one px-2 text-white',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thToggleIcon: `flex-shrink-0 leading-none text-white rtl:ml-2 ${
        isActive ? 'rotate-360' : 'rotate-0'
      }`,
      thToggleIconWidth: '0.625rem',
    };
  },
  clean: props => {
    const { color, isActive } = props;
    const currentColor = color || COLORS.TURQUOISE;
    return {
      thRoot: `${
        isActive
          ? `text-${currentColor}`
          : `text-gray-darker focus:text-${currentColor} hover:text-${currentColor}`
      } px-4 py-3 transition-color`,
      thBody: 'flex h-full items-center',
      thChildren:
        'flex-auto flex font-bold items-center justify-center leading-one text-sm md:text-md',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thToggleIcon: `flex-shrink-0 leading-none text-gray-dark rtl:ml-2 ${
        isActive ? 'rotate-360' : 'rotate-0'
      }`,
      thToggleIconWidth: '0.75rem',
    };
  },
  rounded: props => {
    const { color, isActive } = props;
    const currentColor = color || COLORS.TURQUOISE;
    return {
      thRoot: 'border-1 overflow-hidden rounded-t shadow',
      thBody: `border-t-5 ${
        isActive
          ? `bg-white border-${currentColor}`
          : `bg-transparent border-transparent focus:border-${currentColor} hover:border-${currentColor}`
      } flex h-full items-center -mt-px p-3 md:pt-5 md:pb-8 transition-colors`,
      thChildren: 'flex-grow flex items-center justify-center leading-one px-2 text-xl',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thToggleIcon: `flex-shrink-0 leading-none text-gray-dark rtl:ml-2 ${
        isActive ? 'rotate-360' : 'rotate-0'
      }`,
      thToggleIconWidth: '0.75rem',
    };
  },
  simple: props => {
    const { color, isActive } = props;
    const currentColor = color || COLORS.TURQUOISE;
    return {
      thRoot: `${
        isActive
          ? `text-${currentColor} border-${currentColor} arrow-down arrow-${currentColor}`
          : `text-white hover:text-${currentColor} border-gray-light hover:border-${currentColor}`
      } bg-current border-1 initial-flex font-bold rounded text-sm text-center transition-colors uppercase`,
      thBody: `flex h-full items-center p-2 ${
        isActive
          ? 'text-white'
          : 'text-gray-darker focus:text-white hover:text-white transition-color'
      }`,
      thChildren: 'flex-grow flex items-center justify-center p-2',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 leading-none m-2',
      thToggleIconWidth: '0.625rem',
    };
  },
  lite: props => {
    const { color, isActive } = props;
    const currentColor = color || COLORS.GRAY_DARKER;
    return {
      thRoot: classnames(
        `py-1 px-3 rounded-tiny text-${currentColor} text-md transition-bg-color`,
        {
          'bg-white': !isActive,
          'bg-overlay-blue-10 font-bold': isActive,
        },
      ),
      thBody: 'flex items-center',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 leading-none m-2',
      thToggleIconWidth: '0.625rem',
    };
  },
};
